import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Card, Spinner, Alert } from 'react-bootstrap';
import authService from '../services/authService';
import BackToDashboard from '../components/BackToDashboard';

function EmailSequences() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [targetMarket, setTargetMarket] = useState('');

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = async () => {
    const authResult = await authService.checkAuth();
    if (!authResult.authenticated) {
      navigate('/login');
      return;
    }

    // Get target market for personalized title
    try {
      const marketResponse = await fetch('/api/target-market/primary', {
        credentials: 'include'
      });

      if (marketResponse.ok) {
        const marketData = await marketResponse.json();
        if (marketData.primary_niche) {
          setTargetMarket(marketData.primary_niche.niche_name || '');
        }
      }
    } catch (err) {
      console.error('Error loading target market:', err);
    }

    setLoading(false);
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <BackToDashboard module="assets-creation" />
      <Row className="mb-4">
        <Col>
          <h1>Email Sequences{targetMarket && ` for ${targetMarket}`}</h1>
          <p className="text-muted">
            Create automated email sequences to nurture subscribers and customers throughout their journey.
          </p>
        </Col>
      </Row>

      <Row>
        {/* Welcome Sequence */}
        <Col md={6} lg={4} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>📧 Welcome Sequence</Card.Title>
              <Card.Text>
                6 emails to nurture new lead magnet subscribers, build trust, and prepare them for your core offer.
              </Card.Text>
              <ul className="small mb-3">
                <li>Welcome & deliver lead magnet</li>
                <li>Build relationship & provide value</li>
                <li>Share your story & expertise</li>
                <li>Bridge to core product</li>
                <li>Final call to action</li>
              </ul>
              <div className="d-grid">
                <Button
                  variant="primary"
                  onClick={() => navigate('/email-welcome')}
                >
                  Create Welcome Sequence
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Post-Purchase */}
        <Col md={6} lg={4} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>🎯 Post-Purchase Sequence</Card.Title>
              <Card.Text>
                5-7 emails to onboard new customers, maximize product value, and build loyalty.
              </Card.Text>
              <ul className="small mb-3">
                <li>Welcome & quick start guide</li>
                <li>Implementation roadmap</li>
                <li>Success stories & inspiration</li>
                <li>Advanced strategies</li>
                <li>Community & continued support</li>
              </ul>
              <div className="d-grid">
                <Button
                  variant="primary"
                  onClick={() => navigate('/email-post-purchase')}
                >
                  Create Post-Purchase Sequence
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Alert variant="secondary">
            <strong>These sequences give you a solid foundation to start nurturing your audience.</strong>
            <p className="mb-0 mt-2">
              When you're ready to maximize engagement, the <strong>Command Center</strong> creates
              persona-aware email sequences tailored to each customer type - with your case studies dripped
              strategically, objection handling matched to their specific concerns, and your founder story
              woven into the welcome sequence. All continuously optimized based on open rates and conversions.
            </p>
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}

export default EmailSequences;
